import { useState, useCallback, useEffect } from 'react';
import { darken, Paper, Typography, Grid, Box, List, ListItem, ListItemIcon, ListItemText, makeStyles } from '@material-ui/core';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import { Link } from "react-router-dom";
import dateToString from '../../utils/dateToString';

const useStyles = makeStyles((theme) => ({
    formList: {
        padding: 0,
    },
    formCell: {
        '&:hover': {
            backgroundColor: darken(theme.palette.background.paper, 0.2)
        },
    },
    submitted: {
        color: theme.palette.success.main,
    },
    notSubmitted: {
        color: theme.palette.error.main,
    }
}));

const AvailabilityFormsCard = props => {
    const classes = useStyles();
    const [forms, setForms] = useState([]);
    const getForms = useCallback(async () => {
        const response = await fetch('/api/availability-forms', { credentials: 'include' });
        if (response.status !== 200) return;
        return (await response.json()).body?.forms;
    }, []);
    useEffect(() => {
        getForms().then(forms => {
            if (Array.isArray(forms)) setForms(forms);
        });
    }, [getForms]);

    // nothing to fill in, nothing to show
    if (forms.length === 0) return null;

    return (
        <Paper elevation={6}>
            <Box overflow='hidden'>
                <List className={classes.formList}>
                    <ListItem divider>
                        <ListItemIcon>
                            <EventAvailableIcon />
                        </ListItemIcon>
                        <ListItemText primary='Open availability forms' />
                    </ListItem>
                    {
                        forms.map(form => (
                            <ListItem
                                button
                                divider
                                key={form.id}
                                component={Link}
                                to={"/availability/" + form.id}
                                className={classes.formCell}
                            >
                                <Grid container alignItems='center'>
                                    <Grid item xs={12} sm={6}>
                                        <Typography noWrap>{form.name}</Typography>
                                        <Typography variant='body2' color='textSecondary'>
                                            {form.deadline ? `Deadline: ${dateToString(form.deadline)}` : 'No deadline'}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography
                                            variant='body2'
                                            className={form.submitted ? classes.submitted : classes.notSubmitted}
                                        >
                                            {form.submitted ? 'Submitted' : 'Not submitted'}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </ListItem>
                        ))
                    }
                </List>
            </Box>
        </Paper >
    )
}

export default AvailabilityFormsCard;
